import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function Projects() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Solar Projects</h1>
      <Card>
        <CardHeader>
          <CardTitle>Projects Coming Soon</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Project management with document tracking, quotations, and installation progress.</p>
        </CardContent>
      </Card>
    </div>
  );
}